import './../Player.css';

import React, {useState, useContext, useEffect} from 'react';
import { PlayerContext } from '../PlayerContext';
import BookScreen from './buttons/BookScreen';
import LocationButton from './buttons/LocationButton';
import ShareButton from './buttons/ShareButton';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@mui/material';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import { useMediaQuery } from 'react-responsive';
import { analyticsManager } from '../../index';
import { getStoredPixelConsent } from '../PixelConsentOverlay';
import HoursScreen from './buttons/HoursScreen';
import ReviewsButton from './buttons/ReviewsButton';
import LocationButtonChain from './buttons/LocationButtonChain';
import { getBackgroundVideoElement, isVideoMuted, muteVideo, unmuteVideo, setAudioFromBgVideoOn } from '../Player';
import ChatButton from './buttons/ChatButton';
import NearButton from './buttons/NearButton';
import InfluencerButton from './buttons/InfluencerButton';
import PromoButton from './buttons/PromoButton';
import { useAnimate } from 'framer-motion';
import { printObj } from '../Utils';
import { hasChainRestaurants } from '../chainRestaurantUtils';

function SideMenu(props){
    const { t } = useTranslation();
    const sizeMultiplier = useContext(PlayerContext).get("sizeMultiplier");
    
    const activeFeature = useContext(PlayerContext).get("activeFeature");
    const storyDimensions = useContext(PlayerContext).get("storyDimensions");  
    const playerOnDesktop = useContext(PlayerContext).get("playerOnDesktop"); 
    const fromMaker = useContext(PlayerContext).get("fromMaker");
    const playMode = useContext(PlayerContext).get("playMode");
    const playAudio = useContext(PlayerContext).get("playAudio");
    const setPlayAudio = useContext(PlayerContext).get("setPlayAudio");
    const setAudioAlreadyDisabled = useContext(PlayerContext).get("setAudioAlreadyDisabled");
    const resetAudio = useContext(PlayerContext).get("resetAudio");
    const setResetAudio = useContext(PlayerContext).get("setResetAudio");
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
    const [bgVideoSoundOn, setBgVideoSoundOn] = useState(false);
    const fromDemo = useContext(PlayerContext).get("fromDemo");
    const highlight = useContext(PlayerContext).get("highlight");
    const [scope, animate] = useAnimate();
    const idPrefix = fromDemo ? (fromDemo +"-") : "";
    
    const chainPlaceSelection = activeFeature === "intermediate";
    const sideMenuVisible = activeFeature == null
        || chainPlaceSelection
        || activeFeature === "hours"
        || activeFeature === "reviews"
        || activeFeature === "location"
        || activeFeature === "book"
        || activeFeature === "share"
        || activeFeature === "chat"
        || activeFeature === "near"
        || activeFeature === "promo"
        || activeFeature === "influencer";
    const showHours = sideMenuVisible;
    const showReviews = sideMenuVisible && props.story?.premium;
    const showLocation = sideMenuVisible;
    const showBook = sideMenuVisible;
    const showShare = sideMenuVisible;
    const showChat = sideMenuVisible && props.story?.premium;
    const showNear = sideMenuVisible;
    const showPromo = sideMenuVisible;
    const showInfluencer = sideMenuVisible;

    useEffect(() => {
        if (highlight != null){

            let elementId = null;
            
            if (highlight.includes("avatar")){
                elementId = "restaurant-infos-avatar";
            }            

            const element = document.getElementById(elementId);
            if (elementId != null && element != null){                   
                const animation = async () => {
                    await animate(element, { background: "#FFFFFFFF"}, {duration: 0.6});
                    if (element != null)
                        animate(element, { background: "#FFFFFF00"}, {duration: 0.6});
                }
                
                animation();
            }
        }
      }, [highlight, animate]);

    useEffect(() => {        
        if (resetAudio && playAudio && !props.story.videoSyncWithMusic){
            setPlayAudio(false);            
            
            const volumeBtnOn = document.getElementById(idPrefix + "story-volume-btn-on");
            const volumeBtnOff = document.getElementById(idPrefix + "story-volume-btn-off");
            if (volumeBtnOn != null && volumeBtnOff != null){
                volumeBtnOff.style.visibility = "hidden";
                volumeBtnOn.style.visibility = "visible";
            }            
        }
        else if (resetAudio && props.story.videoSyncWithMusic && bgVideoSoundOn){                  
            toggleSound();
        }

        if (resetAudio){            
            setResetAudio(false);
        }
    }, [resetAudio]);

    useEffect(()=>{
        // reinit volume button if changed dynamically eg in the gallery
        if (activeFeature == null){                               

            if (props.story.videoSyncWithMusic){    
                waitAndUpdateVolumeButtonVisibility();
            }
            else {
                const ambiantPlayer = document.getElementById(idPrefix + "audio-player");
                const volumeBtnOn = document.getElementById(idPrefix + "story-volume-btn-on");
                const volumeBtnOff = document.getElementById(idPrefix + "story-volume-btn-off");
                if (ambiantPlayer != null && volumeBtnOn != null && volumeBtnOff != null){
                    if (! ambiantPlayer.paused || playAudio){                                     
                        volumeBtnOff.style.visibility = "visible";
                        volumeBtnOn.style.visibility = "hidden";                    
                    }
                    else {                                     
                        volumeBtnOff.style.visibility = "hidden";
                        volumeBtnOn.style.visibility = "visible";                    
                    }
                }
            }
        }        
    }, [activeFeature, bgVideoSoundOn])

    function updateVolumeButtonVisibility(){
        const volumeBtnOn = document.getElementById(idPrefix + "story-volume-btn-on");
        const volumeBtnOff = document.getElementById(idPrefix + "story-volume-btn-off");
        if (volumeBtnOn != null && volumeBtnOff != null){
            if (! isVideoMuted()){                         
                volumeBtnOff.style.visibility = "visible";
                volumeBtnOn.style.visibility = "hidden";                                                
            }
            else {                              
                volumeBtnOff.style.visibility = "hidden";
                volumeBtnOn.style.visibility = "visible";                        
            }
        }
    }

    function waitAndUpdateVolumeButtonVisibility(){        
        if (getBackgroundVideoElement()){
            updateVolumeButtonVisibility();
        }
        else {
            setTimeout(updateVolumeButtonVisibility, 200);
        }
    }

    if (activeFeature == null || activeFeature === "intermediate" || activeFeature === "hours" || activeFeature === "reviews"|| activeFeature === "location" || activeFeature === "book" || activeFeature === "share" || activeFeature === "chat" || activeFeature === "near" || activeFeature === "promo" || activeFeature === "influencer"){                               
        return (
            <div className="VideoOverlay">                 
                <HoursScreen show={showHours} storyId={props.storyId} story={props.story} placeDetails={props.placeDetails}/>                                
                <ReviewsButton show={showReviews} storyId={props.storyId} story={props.story} placeDetails={props.placeDetails}/>
                {props.storyId !== "PrRlMX1ISRDTZFNw71xh" && props.storyId !== "LIiKs8PCYFdRvTtSVuVH" && props.storyId !== "LnSX2qKrthKsRmr1vcxc" && props.storyId !== "cJU0Fnom8MTjmokacI3I" && props.storyId !== "LJUbpj5ZyMMdpqmdDc0e" && props.storyId !== "ZcJ9o5kOjzeIvIZ4z0kw" && props.storyId !== "zUEpyuVwo5Tws3hnvFds" && props.storyId !== "YPuRVqGYO2Q2QFKEkRvQ" &&  <LocationButton show={showLocation} storyId={props.storyId} story={props.story} placeDetails={props.placeDetails}/>}
                {(props.storyId === "PrRlMX1ISRDTZFNw71xh" || props.storyId === "LIiKs8PCYFdRvTtSVuVH" || props.storyId === "LnSX2qKrthKsRmr1vcxc" || props.storyId === "cJU0Fnom8MTjmokacI3I" || props.storyId === "LJUbpj5ZyMMdpqmdDc0e" || props.storyId === "ZcJ9o5kOjzeIvIZ4z0kw" || props.storyId === "zUEpyuVwo5Tws3hnvFds" || props.storyId === "YPuRVqGYO2Q2QFKEkRvQ") && <LocationButtonChain show={showLocation} storyId={props.storyId} story={props.story} placeDetails={props.placeDetails}/>}
                <BookScreen show={showBook} className="BookingMenu" storyId={props.storyId} story={props.story} placeDetails={props.placeDetails}/>
                <ShareButton show={showShare} storyId={props.storyId} story={props.story} placeDetails={props.placeDetails}/>
                <ChatButton show={showChat} storyId={props.storyId} story={props.story} placeDetails={props.placeDetails}/>
                <NearButton show={showNear} storyId={props.storyId} story={props.story} placeDetails={props.placeDetails}/>
                <PromoButton show={showPromo} storyId={props.storyId} story={props.story} placeDetails={props.placeDetails}/>
                <InfluencerButton show={showInfluencer} storyId={props.storyId} story={props.story} placeDetails={props.placeDetails}/>
                {activeFeature == null && (props.story.musicUrl || props.story.videoSyncWithMusic)/* && playMode !== "demo"*/ && 
                    <>
                        <IconButton id={idPrefix + "story-volume-btn-on"} aria-label={t('MuteSound')} style={{visibility: 'visible', position: 'absolute', zIndex: 10, top: isTabletOrMobile && fromMaker ? 35 : 0, left: storyDimensions.containerWidth - 48 * sizeMultiplier}} onClick={(e)=>toggleSound(e)}>
                            <VolumeOffIcon style={{color: '#FFFFFF90', width: 32 * sizeMultiplier, height:32 * sizeMultiplier}} />
                        </IconButton>                    
                        <IconButton id={idPrefix + "story-volume-btn-off"} aria-label={t('UnmuteSound')} style={{visibility: 'hidden', position: 'absolute', zIndex: 10, top: isTabletOrMobile && fromMaker ? 35 : 0, left: storyDimensions.containerWidth - 48 * sizeMultiplier}} onClick={(e)=>toggleSound(e)}>
                            <VolumeUpIcon style={{color: '#FFFFFF90', width: 32 * sizeMultiplier, height:32 * sizeMultiplier}} />
                        </IconButton> 
                    </>
                }
                {(props.story.posId != null || hasChainRestaurants(props.story)) && activeFeature == null && showAvatar()}
            </div>
        );        
    }
    else {        
        return null;
    }   
    
    function showAvatar(){        
        let x = storyDimensions.containerWidth + (- 16 - 32) * sizeMultiplier;
        let y = storyDimensions.containerHeight + (- 24 - 32) * sizeMultiplier;
        
        if (props.story.avatarUrl != null){
            return(
                <div id="restaurant-infos-avatar" name="restaurant-infos-avatar" style={{position: 'absolute', left: x, top: y, zIndex: 10, width: 32 * sizeMultiplier, height: 32 * sizeMultiplier}}>
                    <img alt={t('RestaurantAvatarAlt')} src={props.story.avatarUrl} draggable={false} style={{borderRadius: '50%', pointerEvents: 'none', width: 32 * sizeMultiplier, height: 32 * sizeMultiplier, userSelect: 'none', WebkitUserSelect: 'none', WebkitUserDrag: 'none'}} />
                </div>
            );
        }
        else {
            return(
                <div id="restaurant-infos-avatar" name="restaurant-infos-avatar" style={{position: 'absolute', left: x, top: y, zIndex: 10}}>
                    <img alt={t('RestaurantAvatarPlaceholderAlt')} src="/images/avatar_placeholder.png" className="FBAvatarContainer" draggable={false} style={{background: '#FFFFFF', width: 32 * sizeMultiplier, height: 32 * sizeMultiplier, userSelect: 'none', WebkitUserSelect: 'none', WebkitUserDrag: 'none'}} />
                </div>
            );
        }
    }

    function toggleSound(e = null){ 
        if (props.story.videoSyncWithMusic){    
            const volumeBtnOn = document.getElementById(idPrefix + "story-volume-btn-on");
            const volumeBtnOff = document.getElementById(idPrefix + "story-volume-btn-off");
            if (volumeBtnOn != null && volumeBtnOff != null){
                if (! bgVideoSoundOn){                    
                    setBgVideoSoundOn(true);
                    unmuteVideo();
                    volumeBtnOff.style.visibility = "visible";
                    volumeBtnOn.style.visibility = "hidden";
                    trackVolumeOn();
                    setAudioFromBgVideoOn(true);                    
                }
                else {                    
                    setBgVideoSoundOn(false);       
                    muteVideo();             
                    volumeBtnOff.style.visibility = "hidden";
                    volumeBtnOn.style.visibility = "visible";
                    trackVolumeOff();                    
                    setAudioFromBgVideoOn(false);
                }
            }
        }
        else {       
            const ambiantPlayer = document.getElementById(idPrefix + "audio-player");
            const volumeBtnOn = document.getElementById(idPrefix + "story-volume-btn-on");
            const volumeBtnOff = document.getElementById(idPrefix + "story-volume-btn-off");
            if (ambiantPlayer != null && volumeBtnOn != null && volumeBtnOff != null){
                if (! playAudio){
                    setPlayAudio(true);
                    volumeBtnOff.style.visibility = "visible";
                    volumeBtnOn.style.visibility = "hidden";
                    trackVolumeOn();
                }
                else {
                    setPlayAudio(false);
                    setAudioAlreadyDisabled(true);
                    volumeBtnOff.style.visibility = "hidden";
                    volumeBtnOn.style.visibility = "visible";
                    trackVolumeOff();
                }
            }            
        }
        if (e != null){
            e.stopPropagation();
        }
    }

    function trackVolumeOn(){
        analyticsManager.logSetVolumeMusicTag(props.storyId, playMode, true);
        if (getStoredPixelConsent() === 'accepted') {
            if (window.ttq){
                window.ttq.track('SoundAdded');
            }
            if (window.fbq){                    
                window.fbq('trackCustom', 'SoundAdded');
            }
        }
    }

    function trackVolumeOff(){
        analyticsManager.logSetVolumeMusicTag(props.storyId, playMode, false);
        if (getStoredPixelConsent() === 'accepted') {
            if (window.ttq){
                window.ttq.track('SoundRemoved');
            }
            if (window.fbq){                    
                window.fbq('trackCustom', 'SoundRemoved');
            }
        }
    }
}

export default SideMenu;